<mat-icon class="shop-rating-icon">star</mat-icon>
<span class="shop-rating-content ods-typography-microcopy-bold">{{ ratingText }}</span>
<span *ngIf="showCounter && rating > 0" class="shop-rating-counter ods-typography-microcopy-regular"
  >({{ ratingCounterText }})</span
>
